import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SubmitBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '60px 0',
  gap: '40px',
}));

interface IAvmStatusBox {
  color: string;
}

export const AvmStatusBox = styled(Box)<IAvmStatusBox>(({ color }) => ({
  width: '100%',
  padding: '23px 37px',
  margin: '50px 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  background: '#F5F7FB',
  border: `1px solid ${color}`,
  color,
  fontSize: 21,
  textAlign: 'justify',
}));

export const QueuePosition = styled(Typography)(({ theme }) => ({
  width: 210,
  height: '100%',
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '20px',
  padding: '0 8px',
  border: `2px solid ${theme.palette.common.grey}`,
  borderRadius: 10,
  color: theme.palette.common.grey,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
}));
